<template>
  <div
    v-if="!isCaptchaV3"
    class="c-captcha"
  >
    <div class="o-form__group">
      <div class="o-form__row">
        <img
          v-if="captchaImage"
          :src="captchaImage"
          alt="$t('seo.captchaImage')"
          class="c-captcha__img"
        >
        <a
          href="#"
          class="c-captcha__icon o-icon o-icon--refresh o-typography--action"
          @click.prevent="refresh"
        ></a>
      </div>
    </div>
    <div class="o-form__group">
      <div class="o-form__row">
        <label
          for="input-captcha"
          class="c-captcha__label"
        >
          {{ $t('common.captcha') }}
        </label>
      </div>
      <v-input
        id="input-captcha"
        v-model="captcha"
        class="o-form__input"
        :class="{ 'o-form__input--error': error }"
        autocomplete="off"
        :placeholder="$t('subscriber.writeCaptcha')"
        :restriction-rule="RestrictionRule.NO_SPACES"
      ></v-input>
      <div
        v-if="errorMessage"
        class="o-badge__container u-mt-15"
      >
        <v-message
          :message="errorMessage"
          type="error"
        ></v-message>
      </div>
    </div>
  </div>
</template>

<script>
  import { RestrictionRule } from '@/shared/enums';
  import VInput from '@/index/shared/components/input/index.vue';
  import VMessage from '@/index/shared/components/message/index.vue';

  export default {
    components: {
      VInput,
      VMessage,
    },
    enums: {
      RestrictionRule,
    },
    props: {
      error: {
        type: String,
        default: '',
      },
      type: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        captcha: '',
        captchaImage: '',
        errorMessage: '',
        isCaptchaV3: true,
      };
    },
    watch: {
      error() {
        if (this.isCaptchaV3) {
          this.errorMessage = this.$t('subscriber.completeOldCaptcha');
          this.isCaptchaV3 = false;
          return;
        }

        this.errorMessage = this.error;
      },
    },
    methods: {
      refresh() {
        this.captchaImage = this.getImage({ reload: true, type: this.type });
        this.captcha = '';
      },
      getImage({ reload, type }) {
        let url = `/api/captcha/${type}?platform=BROWSER`;
        if (reload) {
          url += `&reload=true&t=${Date.now()}`;
        }
        return url;
      },
      verify() {
        return this.isCaptchaV3
          ? this.$captchaV3.verify(this.type)
          : Promise.resolve({ token: this.captcha, isCaptchaV3: false });
      },
    },
  };
</script>
